import {
    COM_CATALOG_LIST, COM_CATALOG_LIST_SUCCESS, COM_CATALOG_LIST_ERROR,
    COM_CATALOG_PAGE_SET, COM_CATALOG_SEARCH_CHANGE,
    COM_CATALOG_ADD_MODAL_SET, COM_CATALOG_ADD_CHANGE,
    COM_CATALOG_ADD, COM_CATALOG_ADD_SUCCESS, COM_CATALOG_ADD_ERROR,
    COM_CATALOG_EDIT_MODAL_SET, COM_CATALOG_EDIT_SET_DATA,
    COM_CATALOG_UPDATE, COM_CATALOG_UPDATE_SUCCESS, COM_CATALOG_UPDATE_ERROR,
    COM_CATALOG_CANCEL_MODAL_SET, COM_CATALOG_CANCEL_SET_DATA,
    COM_CATALOG_DETAIL_LIST, COM_CATALOG_DETAIL_LIST_SUCCESS, COM_CATALOG_DETAIL_LIST_ERROR,
    COM_CATALOG_DETAIL_PAGE_SET,
    COM_CATALOG_DETAIL_ADD_MODAL_SET, COM_CATALOG_DETAIL_ADD_CHANGE,
    COM_CATALOG_DETAIL_ADD, COM_CATALOG_DETAIL_ADD_SUCCESS, COM_CATALOG_DETAIL_ADD_ERROR,
    COM_CATALOG_DETAIL_EDIT_MODAL_SET, COM_CATALOG_DETAIL_EDIT_SET_DATA,
    COM_CATALOG_DETAIL_UPDATE, COM_CATALOG_DETAIL_UPDATE_SUCCESS, COM_CATALOG_DETAIL_UPDATE_ERROR,
    COM_CATALOG_DETAIL_CANCEL_MODAL_SET, COM_CATALOG_DETAIL_CANCEL_SET_DATA,
} from '../../actions';

const INIT_STATE = {
    loading: false,
    list: { page: { current: 1, rows: 10 }, data: [], total_pages: 0, total_item: 0 },
    search: { data: { code: '', name: '' } },
    add: { data: { code: '', name: '' }, modal: false, loading: false, message: '' },
    edit: { data: null, modal: false, loading: false, message: '' },
    cancel: { data: null, modal: false },
    detail: {
        loading: false,
        list: { page: { current: 1, rows: 5 }, data: [], total_pages: 0, total_item: 0 },
        add: { data: { code: '', name: '', orden: '' }, modal: false, loading: false, message: '' },
        edit: { data: null, modal: false, loading: false, message: '' },
        cancel: { data: null, modal: false },
    },
    error: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        // Catalog List
        case COM_CATALOG_LIST: return { ...state, loading: true };
        case COM_CATALOG_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
        case COM_CATALOG_LIST_ERROR: return { ...state, loading: false, error: true };
        case COM_CATALOG_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
        case COM_CATALOG_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };

        // Catalog Add
        case COM_CATALOG_ADD_MODAL_SET: return { ...state, add: { ...state.add, modal: action.payload } };
        case COM_CATALOG_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, ...action.payload } } };
        case COM_CATALOG_ADD: return { ...state, add: { ...state.add, loading: true } };
        case COM_CATALOG_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, modal: false, message: action.payload.message, data: { code: '', name: '' } } };
        case COM_CATALOG_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload } };

        // Catalog Edit
        case COM_CATALOG_EDIT_MODAL_SET: return { ...state, edit: { ...state.edit, modal: action.payload } };
        case COM_CATALOG_EDIT_SET_DATA: return { ...state, edit: { ...state.edit, data: action.payload } };
        case COM_CATALOG_UPDATE: return { ...state, edit: { ...state.edit, loading: true } };
        case COM_CATALOG_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, loading: false, message: action.payload.message } };
        case COM_CATALOG_UPDATE_ERROR: return { ...state, edit: { ...state.edit, loading: false, message: action.payload } };

        // Catalog Cancel
        case COM_CATALOG_CANCEL_MODAL_SET: return { ...state, cancel: { ...state.cancel, modal: action.payload } };
        case COM_CATALOG_CANCEL_SET_DATA: return { ...state, cancel: { ...state.cancel, data: action.payload } };

        // Catalog Detail List
        case COM_CATALOG_DETAIL_LIST: return { ...state, detail: { ...state.detail, loading: true } };
        case COM_CATALOG_DETAIL_LIST_SUCCESS: return { ...state, detail: { ...state.detail, loading: false, list: { ...state.detail.list, ...action.payload } } };
        case COM_CATALOG_DETAIL_LIST_ERROR: return { ...state, detail: { ...state.detail, loading: false } };
        case COM_CATALOG_DETAIL_PAGE_SET: return { ...state, detail: { ...state.detail, list: { ...state.detail.list, page: { ...state.detail.list.page, ...action.payload } } } };

        // Catalog Detail Add
        case COM_CATALOG_DETAIL_ADD_MODAL_SET: return { ...state, detail: { ...state.detail, add: { ...state.detail.add, modal: action.payload } } };
        case COM_CATALOG_DETAIL_ADD_CHANGE: return { ...state, detail: { ...state.detail, add: { ...state.detail.add, data: { ...state.detail.add.data, ...action.payload } } } };
        case COM_CATALOG_DETAIL_ADD: return { ...state, detail: { ...state.detail, add: { ...state.detail.add, loading: true } } };
        case COM_CATALOG_DETAIL_ADD_SUCCESS: return { ...state, detail: { ...state.detail, add: { ...state.detail.add, loading: false, modal: false, message: action.payload.message, data: { code: '', name: '', orden: '' } } } };
        case COM_CATALOG_DETAIL_ADD_ERROR: return { ...state, detail: { ...state.detail, add: { ...state.detail.add, loading: false, message: action.payload } } };

        // Catalog Detail Edit
        case COM_CATALOG_DETAIL_EDIT_MODAL_SET: return { ...state, detail: { ...state.detail, edit: { ...state.detail.edit, modal: action.payload } } };
        case COM_CATALOG_DETAIL_EDIT_SET_DATA: return { ...state, detail: { ...state.detail, edit: { ...state.detail.edit, data: action.payload } } };
        case COM_CATALOG_DETAIL_UPDATE: return { ...state, detail: { ...state.detail, edit: { ...state.detail.edit, loading: true } } };
        case COM_CATALOG_DETAIL_UPDATE_SUCCESS: return { ...state, detail: { ...state.detail, edit: { ...state.detail.edit, loading: false, modal: false, message: action.payload.message } } };
        case COM_CATALOG_DETAIL_UPDATE_ERROR: return { ...state, detail: { ...state.detail, edit: { ...state.detail.edit, loading: false, message: action.payload } } };

        // Catalog Detail Cancel
        case COM_CATALOG_DETAIL_CANCEL_MODAL_SET: return { ...state, detail: { ...state.detail, cancel: { ...state.detail.cancel, modal: action.payload } } };
        case COM_CATALOG_DETAIL_CANCEL_SET_DATA: return { ...state, detail: { ...state.detail, cancel: { ...state.detail.cancel, data: action.payload } } };

        default: return { ...state };
    }
};
